module.exports = __webpack_public_path__ + "img/Frame-76.71a90888.svg";